import { RendererService } from "../renderer.service";
import * as THREE from "three";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";

@Component({
  selector: "app-threed",
  templateUrl: "./threed.component.html",
  styleUrls: ["./threed.component.css"]
})
export class ThreedComponent implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    // Salabo back bug.
    // (function(window, location) {
    // history.replaceState(
    // null,
    // document.title,
    // location.pathname + "#!/stealingyourhistory"
    // );
    // history.pushState(null, document.title, location.pathname);

    // window.addEventListener(
    // "popstate",
    // function() {
    // if (location.hash === "#!/stealingyourhistory") {
    // history.replaceState(null, document.title, location.pathname);
    // setTimeout(function() {
    // location.replace("http://talizpete.venta.lv/"); //pagaidu variants
    // }, 0);
    // }
    // },
    // false
    // );
    // })(window, location);
    // pagaidam izslegsim, paskatisos vai nevar kaut ka labak

    //Cesium.Ion.defaultAccessToken = null; //nevaru un nevajag izmantot cesium ion
    var cesiumContainer = document.getElementById("cesiumContainer");

    var extent = new Cesium.Rectangle.fromDegrees(
      21.580987275570255,
      57.40203177350442,
      21.590807433653628,
      57.40368847483405
    );

    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = extent;
    Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;

    var viewer = new Cesium.Viewer("cesiumContainer", {
      imageryProvider: new Cesium.OpenStreetMapImageryProvider({
        //izmantojot tikai openstreetmaps
        url: "//a.tile.openstreetmap.org/"
      }),

      //Parliek cesium uz "offline" mode. Netiek izmantots Cesium ion.
      //imageryProvider: new Cesium.TileMapServiceImageryProvider({
      //  url: Cesium.buildModuleUrl("Assets/Textures/NaturalEarthII")
      //}),
      baseLayerPicker: false,
      geocoder: false,

      animation: false, //paslepj to superigo 2000s era pulksteni
      timeline: false,
      selectionIndicator: false
      //terrainProvider : Cesium.createWorldTerrain() //aprok majas
    });

    //viewer._cesiumWidget._creditContainer.parentNode.removeChild(
    //  viewer._cesiumWidget._creditContainer
    //); //paslepj cesium ion logo (drikst, ja neizmanto ion)
    viewer.fullscreenButton.viewModel.fullscreenElement = document.getElementById(
      "cesiumContainer"
    ); //salabots fullscreen bug, tagad nerada toolbar

    viewer.camera.setView({ destination: extent });

    //3D modeļi. Tos failus var likt cik grib, var arī vienā.
    viewer.dataSources.add(
      Cesium.KmlDataSource.load("../assets/ostgals.kml", {
        camera: viewer.scene.camera,
        canvas: viewer.scene.canvas
      })
    );
    viewer.dataSources.add(
      Cesium.KmlDataSource.load("../assets/devinstavenes.kml", {
        camera: viewer.scene.camera,
        canvas: viewer.scene.canvas
      })
    );
    viewer.dataSources.add(
      Cesium.KmlDataSource.load("../assets/galinciems.kml", {
        camera: viewer.scene.camera,
        canvas: viewer.scene.canvas
      })
    );
    viewer.dataSources.add(
      Cesium.KmlDataSource.load("../assets/parventa1.kml", {
        camera: viewer.scene.camera,
        canvas: viewer.scene.canvas
      })
    );
    viewer.dataSources.add(
      Cesium.KmlDataSource.load("../assets/buildingsGenerated.kml", {
        camera: viewer.scene.camera,
        canvas: viewer.scene.canvas
      })
    );

    //var layers = viewer.scene.imageryLayers;
    //layers.addImageryProvider(new Cesium.SingleTileImageryProvider({
    //  url : 'http://talizpete.venta.lv:8090/sub/57.3584367437361493,21.5214005269093249,57.4324888661053237,21.6393137351526228,Ēnu karte (ziema 21.12),.png',
    //  rectangle : Cesium.Rectangle.fromDegrees(21.5214005269093249,57.3584367437361493,21.6393137351526228,57.4324888661053237)
    //}));
  }
}
